import type { Container, Sprite } from 'pixi.js';
import { onLayoutPopulated } from '../populate';
import { insertAvatar } from '../../../game/utils/insertAvatar';
import type { App } from '../../../app/App';

export function insertAvatarSPL(app: App): void {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  onLayoutPopulated.connect((layout: { root: Container; insertAvatar_SPL?: (Sprite & {data: {insertAvatar_SPL?: string}})[]; }) => {
    if (!layout.insertAvatar_SPL) return;

    const { avatarUrl } = app.platform.getCurrentPlayer();

    if (!avatarUrl) return;

    layout.insertAvatar_SPL.forEach((sprite) => {
      const variableName = sprite.data.insertAvatar_SPL;

      if (!variableName) return;

      const variableValue = app.utils.variableBank.getVariable(variableName);

      if (!variableValue) return;
      if (variableValue.type !== 'text') return;

      void insertAvatar(sprite, variableValue.value);
    });
  });
}
